import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Box from '../box/box.jsx';
import styles from './connection-modal.css';

const UnavailableStep = props => (
    <Box className={styles.body}>
        <Box className={styles.activityArea}>
            <div className={styles.centeredRow}>
                <div className={styles.peripheralActivity}>
                    <img
                        className={styles.errorIcon}
                        src={props.connectionTipIconURL || '/static/assets/c25c9919121ad3094ae6d673228866d0.svg'}
                    />
                </div>
            </div>
            <div className={styles.instructions}>
                <p>Cihaz kullanılamıyor</p>
                <p>Lütfen cihazın açık ve bağlı olduğundan emin olun.</p>
            </div>
        </Box>
        <Box className={styles.bottomArea}>
            <div className={classNames(styles.bottomAreaItem)}>
                <button
                    className={classNames(styles.connectionButton)}
                    onClick={props.onHelp}
                >
                    Yardım
                </button>
            </div>
            <div className={classNames(styles.bottomAreaItem)}>
                <button
                    className={classNames(styles.connectionButton)}
                    onClick={props.onBack}
                >
                    <img
                        className={classNames(styles.buttonIconLeft, styles.buttonIconBack)}
                        src="/static/assets/0e8b8f54a1d76b6e2b1c30b805cabe3d.svg"
                    />
                    Geri
                </button>
            </div>
        </Box>
    </Box>
);

UnavailableStep.propTypes = {
    connectionTipIconURL: PropTypes.string,
    onBack: PropTypes.func.isRequired,
    onHelp: PropTypes.func.isRequired
};

export default UnavailableStep;
